import { useSelector } from 'react-redux';

import { ROUTES } from 'theSource/app/routes';
import { NavLinks } from '../NavLinks';
import { NavLinkGroup } from '../NavLinkGroup';
import { selectMfaEnabled } from 'theSource/features';

export const AccountLinksGroup = () => {
  const mfaEnabled = useSelector(selectMfaEnabled);

  const accountGroupLinks = Object.values(ROUTES.additional.account);
  const accountGroupLinksFiltered = mfaEnabled ?
    accountGroupLinks :
    accountGroupLinks.filter((link) => 
      link.name !== 'navigation.additional:account.securityPreferencesTitle'
    );

  return (
    <NavLinkGroup heading="account">
      <NavLinks navRoutes={accountGroupLinksFiltered} />
    </NavLinkGroup>
  );
};
